module.exports = __webpack_public_path__ + "static/media/help-tile-02@3x.394d38e2.png";